import api from "@/lib/api";

function hHeader() {
  const hid = typeof document !== "undefined" ? document.cookie
    .split(";").map(c => c.trim()).find(c => c.startsWith("active_hotel_id=")) : null;
  const val = hid ? decodeURIComponent(hid.split("=")[1]) : null;
  return val ? { "X-Hocp-Hotel": val } : {};
}
const H = () => ({ headers: hHeader() });

export const twinAPI = {
  overview:      ()               => api.get("/sup/v1/twin/overview", H()).then(r => r.data),
  store:         (id)             => api.get(`/sup/v1/twin/store/${id}`, H()).then(r => r.data),
  movements:     (limit = 20)     => api.get("/sup/v1/twin/live-movements", { ...H(), params: { limit } }).then(r => r.data),
  search:        (q, limit = 12)  => api.get("/sup/v1/twin/search", { ...H(), params: { q, limit } }).then(r => r.data),
};

export const fmtINR = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });
export const fmtINRShort = (n) => {
  const v = Number(n || 0);
  if (v >= 10000000) return "₹" + (v / 10000000).toFixed(1) + "Cr";
  if (v >= 100000)   return "₹" + (v / 100000).toFixed(1) + "L";
  if (v >= 1000)     return "₹" + (v / 1000).toFixed(1) + "k";
  return "₹" + v.toLocaleString("en-IN");
};
